import { render } from "./MoveToTrash.vue?vue&type=template&id=23af3d82"
import script from "./MoveToTrash.vue?vue&type=script&lang=js"
export * from "./MoveToTrash.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__